module.exports = __webpack_public_path__ + "img/no-data.ff5a65b4.png";